import useAct from '../useAct'
import LogoSetting from './LogoSetting'
import './Form.scoped.scss'

export default function VolunteerPageSettings() {
  const act = useAct()
  const {
    volunteerIntroText,
    volunteerHeroImage,
    supportEmail,
  } = useSel((s) => s.brand)
  const { validationErrors } = useSel((s) => s.local)

  return <div>
    <div className='box form'>
      <h2 className='no-margin-top'>Volunteer Page</h2>
      <p className='small bold dark-grey'>Customise the look and feel of the volunteer homepage that your volunteers see when they log in.</p>

      <div className="field margin-top">
        <label>Intro Text</label>
        <p className='small bold dark-grey'>This replaces the default "Thanks for being involved. Let's get started." message on the volunteer homepage.</p>
        <input
          type='text'
          className='full-width margin-bottom'
          value={volunteerIntroText || ''}
          placeholder="Thanks for being involved. Let's get started."
          onChange={(e) => act.brand.upsert({ volunteerIntroText: e.target.value })}
        />
      </div>

      <div className="field margin-top">
        <label>Support Email</label>
        <p className='small bold dark-grey'>This email is shown to volunteers when they need help. It is displayed at the bottom of the volunteer homepage.</p>
        <input
          type='email'
          className={`full-width margin-bottom ${validationErrors['supportEmail'] ? 'invalid' : ''}`}
          value={supportEmail || ''}
          placeholder="support@example.com"
          onChange={(e) => act.brand.upsert({ supportEmail: e.target.value })}
        />
      </div>

      <LogoSetting
        label="Hero Image"
        value={volunteerHeroImage}
        onUploaded={(val) => act.brand.upsert({ volunteerHeroImage: val[0] })}
        helpText="This image is displayed as a banner at the top of the volunteer homepage. Recommended width of at least 1200px with an aspect ratio of roughly 3:1."
        className="light"
      />
    </div>
  </div>
}
